import { useState } from 'react';
import {HashRouter} from "react-router-dom";
import { NavLink } from "../atoms/TextContainers";
import './Nav.css'

function Navigation() {
    const [open, setOpen] = useState(false);
    const logo = process.env.REACT_APP_CDN_URL + "grc-logo.png";

    const close = () => setOpen(false);

    return (
        <div className="ham-container">
            {/* Mobile logo → Startseite */}
            <a href="/" className="logoBox2">
                <img src={logo} alt="grc Logo" className="logo" />
            </a>

            {/* Hamburger button */}
            <button
                className={`hamburgerBtn${open ? ' hamburgerBtn--open' : ''}`}
                onClick={() => setOpen(o => !o)}
                aria-label="Menü"
                aria-expanded={open}
            >
                <span className="line line1" />
                <span className="line line2" />
                <span className="line line3" />
            </button>

            <div className="spacer" />

            {/* Nav links */}
            <div className={`navContainer${open ? ' navContainer--open' : ''}`} onClick={close}>
                <HashRouter>
                    <a href="/" className="ref navHomeLink">
                        <div className="navItem inactive" id="home">Startseite</div>
                    </a>
                    <NavLink id="club"      text="Verein"    destination="/club"/>
                    <NavLink id="training"  text="Training"  destination="/training"/>
                    <NavLink id="gallery"   text="Galerie"   destination="/gallery"/>
                    <a href="/" className="logoBox" onClick={close}>
                        <img src={logo} alt="grc Logo" className="logo" />
                    </a>
                    <NavLink id="spee"      text="Spee Cup"  destination="/spee"/>
                    <NavLink id="sponsors"  text="Sponsoren" destination="/sponsors"/>
                    <NavLink id="contact"   text="Kontakt"   destination="/contact"/>
                </HashRouter>
            </div>
        </div>
    );
}

export default Navigation;
